import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ReportsService } from '../../reports.service';
import { NgForm } from '@angular/forms';
import { EntitiesService } from 'src/app/configuration/entities.service';
import { ComponentService } from '../../../core/view/component.service';

@Component({
  selector: 'app-report-masive-update',
  templateUrl: './report-masive-update.component.html',
  styleUrls: ['./report-masive-update.component.scss']
})
export class ReportMasiveUpdateComponent implements OnInit {

  @ViewChild("formDetails") public formDetails: NgForm;

  public yes_no = [
    { name: 'Si', value: 1 },
    { name: 'No', value: 0 },
  ];

  public columns = [];
  public selectedColumn : any = {};
  public entity: any = [];
  public temporalCombos:any = {};
  public rowsLength: number;

  public entitiesToFilter: any = [];
  public filterValuesOptions: any[] = [];

  constructor(private route: ActivatedRoute,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
    private datePipe: DatePipe,
    private reportsService: ReportsService,
    private entitiesService: EntitiesService, private componentService: ComponentService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loadData(this.config.data.columns, this.config.data.entity, this.config.data.rowsLength);
    });
  }

  loadData(columns, entity, rowsLength) {
    console.log(entity);

    this.entitiesService.getByCode(entity.code).subscribe(
      data => {
        entity.fields.forEach(field => {
          this.entity = data;
          field.entityField = this.entity.fields.find(m => m.id == field.entity_field_id);
        });
        
        this.entitiesToFilter = this.getSelectableEntityFields();
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
    this.columns = columns;
    this.rowsLength = rowsLength;
  }


  getSelectableEntityFields() {
    if (this.entity?.fields != null) {

      //obtener entidades
      let entities = [];
      this.entity.fields.forEach(field => {
        if (field.model_property == "zone_id") {
        }
        if (this.componentService.isVisibleFieldCustom({ entityField: field }, null)) {
          entities.push(field);
          if (entities.find(m => m.code == field.entity_code) == null) {
            //Lo cogemos del field porque lo traemos para las entidades que no son la principal.
            entities.push({ code: field.entity_code, name: field.entity_name, shortname: field.shortname });
          }
        }
       /* if (entities.find(m => m.code == field.entity_code) == null) {
          entities.push({ code: field.entity_code, name: field.entity_name });
        }*/
      });
      let dataAux = [];

      dataAux = entities.filter(m => m.configuration?.allowedUpdateMasive);

    /* entities.forEach((entity) => {
        data.push({
          entity: entity.name,
          fields: this.entity.fields.filter(m=>m.configuration?.allowedUpdateMasive).filter(m => m.entity_code == entity.code)
        });
      });*/
      let data = []
      entities.forEach((entity) => {
        let fields = dataAux.filter(m => m.entity_code == entity.code);
        fields.forEach((f) => {
          data.push({
            id: f.id,
            entity_field_id: f.id,
            entity_field_model_property: f.full_model_property,
            entity_field_model_property_label: f.full_model_property_label,
            description: (entity.shortname ? entity.shortname : entity.name) + " / " + f.description,
            label: (entity.shortname ? entity.shortname : entity.name) + " / " + f.description//(typeof (f.label) === "undefined" ? "" : f.label)
          });
        })

      });
      return data;
    } else {
      return [];
    }
  }
  getComboOptions(field, text) {
    if (field.configuration.options?.type == "api") {
      var url = "/api/" + field.configuration.options.url;
      if (text == "undefined") text = null;
      this.temporalCombos[field.id] = [];
      this.reportsService.customVoidCombos(url, { text: text }).subscribe(
        data => {

          this.temporalCombos[field.id] = data.rows;
          if (field.configuration.options.url == "users/combo" || field.configuration.options.url == "users") {
            //Añadimor el usuario actual
            this.temporalCombos[field.id].push({ id: -1, name: "Usuario actual" });
          }
          if (field.configuration.options.url == "transactionsStatus") {
            let transaction_type_id = (field.entity_code == "oportunity" ? 1 : 2);
            this.temporalCombos[field.id] = this.temporalCombos[field.id].filter(function (e) { return e.transaction_type_id == transaction_type_id });
          }
          //

          if (field.data_type == "list" || field.data_type == 'list_multiple') {
            field.configuration.options.items.forEach(element => {
              let id = field.configuration.field_value;
              let text = field.configuration.field_text;
              if (typeof this.filterValuesOptions[element.entity_field_id] === "undefined") this.filterValuesOptions[element.entity_field_id] = [];
              this.filterValuesOptions[element.entity_field_id].push({ [id]: element.code, [text]: element.text });

            });
          } else if (field.data_type == "number") {
            //if (typeof this.filterValuesOptions[field.id] === "undefined") 
            this.filterValuesOptions[field.id] = [];
            this.temporalCombos[field.id].forEach(element => {

              element.text = element[field.configuration.field_text];
              element.code = element[field.configuration.field_value];
              this.filterValuesOptions[field.id].push(element);
            })
          }
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    } else {
      field.configuration.options.items.forEach(e => {
        e.name = e.text;
        e.id = e.code;
      })
      this.temporalCombos[field.id] = field.configuration.options.items
      if (typeof this.filterValuesOptions[field.id] === "undefined") this.filterValuesOptions[field.id] = [];
      this.temporalCombos[field.id].forEach(element => {
        this.filterValuesOptions[field.id].push(element);
      })
    }

  }
  changeColumn(event:any, fieldConfig:any){

      let field = this.entity.fields.find(m => m.id == this.selectedColumn.entity_field_id);
    this.selectedColumn.entity_field_model_property = field.full_model_property;
    console.log(field.control_type);
    if (field.control_type == "dropdown" || field.control_type == "dropdown-multiple") {
      this.getComboOptions(field, null);
          /*if(field.data_type=="list"){
            //los datos están aqui
            //this.temporalCombos[field.id] = field.configuration.options.items;
            this.getComboOptions(field);
          }else if(field.data_type =="number"){
            //tenemos que hacer petición para obtener la lista de datos.
            var url = "/api/" + field.configuration.options.url;
            this.reportsService.customVoidCombos(url, {}).subscribe(
              data => { 
                this.temporalCombos[field.id] = data.rows;           
                if(field.configuration.options.url ==  "users"){
                    //Añadimor el usuario actual
                    this.temporalCombos[field.id].push({id: -1, name: "Usuario actual"});
                }           
              },
              error => {
                this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
              }
            );
          }*/
        }

  }

  getFilterOptionsOrValueType(element, filter) {
    if (typeof (this.entity.fields) !== "undefined") {
      let field = this.entity.fields.filter(m => m.id == element.entity_field_id);
      if (field.length > 0) {
        //if (filter) return this.filterOptions(field[0].data_type, field[0].control_type, field[0]); ya no se llama desde la vista.
        if (!filter) return this.valueTypes(field[0].data_type, field[0].control_type);
      }
    }
  }
  

  valueTypes(data_type: string, control_type: string) {
    let valueType = "";
    if (data_type == "string") {
      valueType = 'input-text';
    }
    else if ((data_type == "number" && control_type != "dropdown") || data_type == "date") {
      valueType = (data_type == "number" ? 'input-number' : "input-datetime");
    }
    else if (data_type == "list") {
      valueType = "list";
    } else if (data_type == "list_multiple") {
      valueType = 'dropdown-multiple';
    } else if (data_type == "boolean") {
      valueType = "boolean"
    } else {
      valueType = 'input-text';
    }

    if (control_type == "dropdown") {
      valueType = 'input-dropdown';
    }
    return valueType;
  }

  getFilterComboOptionsText(element: any, field_text: boolean) {
    let field = this.entity.fields.filter(m => m.id == element.entity_field_id);
    if (field.length > 0) {
      if (field_text) {
        return field[0].configuration.field_text;
      } else {
        return field[0].configuration.field_value;
      }
    }
  }

  /*getFilterOptionsData(element: any){
    
    let filterOptions: any[] = [];
    let field = this.entity.fields.filter(m => m.id == element.entity_field_id);
    if(field.length > 0){

      if (field[0].data_type == "list") {
        field[0].configuration.options.items.forEach(element => {
          filterOptions.push({id: element.code, name: element.text});
        });
      } else if (field[0].data_type == "number") {       
        return this.temporalCombos[element.entity_field_id];
      }
    }
    return filterOptions;
  }*/

  updateColumns(){
    this.coreDialogService.confirm({
      message: '¿Está seguro de que desea modificar el valor a los ' + this.rowsLength + ' elementos del informe?',
      header: 'Confirmación de actualización',
      icon: 'pi pi-info-circle',
      accept: () => {
        console.log(this.selectedColumn);
        this.dynamicDialogRef.close(this.selectedColumn);
      },
      reject: () => {
      }
    });
  }                                                   
  cancel(){
    this.dynamicDialogRef.close();
  }

}
